export default __webpack_public_path__ + "static/media/7.eae82a7b.jpg";